var urls = {
  recentSearchUrl: '/account/api/userSearch',
  c360SearchUrl: '/account/api/search/C360Search',
  searchResultsUrl: '/account/searchresults',
  c360ScopesUrl: '/account/api/configs',
  vehicleDetails: '/account/vehicledetails'
};
var CONTACT_TYPES = ['CCContact', 'CCContactEmail', 'CCContactPhone', 'AMContact', 'ContactPhone'];
var DEFAULT_SCOPE_OPTIONS = [{
  label: 'All',
  value: 'all',
  id: '1'
}, {
  label: 'Account ID',
  value: 'account_id',
  id: '2'
}, {
  label: 'Contact ID',
  value: 'contact_id',
  id: '3'
}, {
  label: 'Email',
  value: 'email, contact_primary_email',
  id: '4'
}, {
  fullLabel: 'EN Reference',
  label: 'Order Number',
  value: 'order_number',
  id: '5'
}, {
  label: 'ERP ID',
  value: 'erp_customer_id',
  id: '6'
}, {
  label: 'Federation ID',
  value: 'federation_id',
  id: '7'
}, {
  label: 'Job ID',
  value: 'job_id',
  id: '8'
}, {
  label: 'Name',
  value: 'full_name, contact_full_name',
  id: '9'
}, {
  label: 'Order Number',
  value: 'order_number_duplicate',
  id: '10'
}, {
  label: 'Phone Number',
  value: 'phone',
  id: '11'
}, {
  label: 'Tax ID',
  value: 'tax_id',
  id: '12'
}, {
  label: 'UID',
  value: 'uid',
  id: '13'
}, {
  label: 'Vehicle Map ID',
  value: 'vehicle_map_id',
  id: '14'
}, {
  label: 'VIN',
  value: 'asset_vin, vin, asset_last_six_vin, last_six_vin',
  id: '15'
}];

export { CONTACT_TYPES, DEFAULT_SCOPE_OPTIONS, urls };
